import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 6.215a9.83 9.83 0 0 1 6.894 2.81 9.52 9.52 0 0 1 2.856 6.788 9.52 9.52 0 0 1-2.856 6.786A9.83 9.83 0 0 1 16 25.41a9.83 9.83 0 0 1-6.894-2.81 9.52 9.52 0 0 1-2.856-6.788 9.52 9.52 0 0 1 2.856-6.786A9.83 9.83 0 0 1 16 6.215m0 21.41c3.183 0 6.235-1.244 8.485-3.46A11.72 11.72 0 0 0 28 15.813a11.72 11.72 0 0 0-3.515-8.353A12.1 12.1 0 0 0 16 4a12.1 12.1 0 0 0-8.485 3.46A11.72 11.72 0 0 0 4 15.813a11.72 11.72 0 0 0 3.515 8.352A12.1 12.1 0 0 0 16 27.625m5.297-13.981a1.09 1.09 0 0 0 0-1.564 1.137 1.137 0 0 0-1.59 0L14.506 17.2l-2.203-2.168a1.133 1.133 0 0 0-1.59 0 1.095 1.095 0 0 0 0 1.564l3 2.953c.441.434 1.154.434 1.59 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }